import { Component } from '@angular/core';
import { UserService } from '@app/services/user.service';
import { Router } from '@angular/router';

@Component(
  {
    template: ''
})

export class SwitchToBetaComponent {

  constructor(private userService: UserService, private router: Router) { 
    this.userService.me()
      .then(user => {
          if (user) {
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.router.navigate(['/catalogs'])
          }
      });
  }

}
